import React, { useEffect, useState } from "react";

import { useModal } from "../../../providers/ModalProvider/ModalProvider";

import { formatCurrency } from "../../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import { PayoutSchedule } from "../../ModalContent/PayoutSchedule";
import { ConfirmWithdraw } from "../../ModalContent/ConfirmWithdraw";

export default function Balance({ account, balance, bankAccount, payouts }) {
  const { openModal, closeModal } = useModal();

  const [payoutSchedule, setPayoutSchedule] = useState({
    mode: "automatic",
    interval: account?.settings?.payouts?.schedule?.interval,
  });

  const inTransit = payouts
    ? payouts
        ?.filter((payout) => payout.status === "in_transit")
        ?.reduce((acc, cur) => acc + cur.amount, 0)
    : 0;

  // available + pending
  const availableBalance =
    balance?.available[0]?.amount + balance?.pending[0]?.amount;

  const openScheduleModal = () => {
    openModal(
      PayoutSchedule,
      {
        schedule: payoutSchedule,
        setSchedule: setPayoutSchedule,
        closeModal: closeModal,
      },
      { className: "modal-xl", contentClassName: "" },
    );
  };

  const openWithdrawModal = () => {
    openModal(
      ConfirmWithdraw,
      {
        amount: balance?.instant_available[0]?.amount / 100,
        currency: balance?.instant_available[0]?.currency,
        account: bankAccount?.data[0]?.bank_name,
      },
      { className: "modal--lg modal-sm", contentClassName: "" },
    );
  };
  return (
    <>
      <Card body>
        <Stack
          direction="horizontal"
          gap={3}
          className="card-body-heading card-body-heading--sm balance"
        >
          <Card.Title as="h5">Balance</Card.Title>
        </Stack>
        <Stack gap={4}>
          <Stack
            direction="horizontal"
            gap={4}
            className="justify-content-between"
          >
            <Stack gap={1}>
              <span className="small small-bold">Available balance</span>
              <span className="h4 m-0">
                {availableBalance && (
                  <>
                    <span>
                      {formatCurrency((availableBalance + inTransit) / 100)}
                    </span>{" "}
                    <span className="text-uppercase">
                      {balance.available[0]?.currency}
                    </span>
                  </>
                )}
              </span>
            </Stack>
            {/* {payoutSchedule?.mode === "manual" && (
              <Button
                size="lg"
                onClick={openWithdrawModal}
                disabled={balance?.instant_available[0]?.amount / 100 === 0}
              >
                Withdraw
              </Button>
            )} */}
          </Stack>
          <Row>
            <Col xs={6}>
              <Card body className="card--sm card-with-border">
                <Stack gap={1}>
                  <Card.Title as="h5" className="small small-bold">
                    Future payouts
                  </Card.Title>
                  <span className="normal normal-bold">
                    <span>
                      {formatCurrency(balance.pending[0]?.amount / 100)}
                    </span>{" "}
                    <span className="text-uppercase">
                      {balance?.available[0]?.currency}
                    </span>
                  </span>
                </Stack>
              </Card>
            </Col>
            <Col xs={6}>
              <Card body className="card--sm card-with-border">
                <Stack gap={1}>
                  <Card.Title as="h5" className="small small-bold">
                    In transit to bank
                  </Card.Title>
                  <span className="normal normal-bold">
                    <span>{formatCurrency(inTransit / 100)}</span>{" "}
                    <span className="text-uppercase">
                      {balance?.available[0]?.currency}
                    </span>
                  </span>
                </Stack>
              </Card>
            </Col>
          </Row>
          <div>
            <h6 className="caption caption-bold mb-3">Linked account</h6>
            <Card body className="card--xs card--dark">
              <Stack direction="horizontal" gap={3} className="bank">
                <Stack gap={2} className="justify-content-center">
                  <Card.Title as="h5" className="small small-bold">
                    {bankAccount?.data[0]?.bank_name}
                  </Card.Title>
                  <span className="caption">
                    ••••• {bankAccount?.data[0]?.last4}
                  </span>
                </Stack>
              </Stack>
            </Card>
          </div>
          <Stack as="ul" className="small" gap={2}>
            <Stack as="li" direction="horizontal" gap={5}>
              <span className="me-5">Payout schedule</span>
              <Stack direction="horizontal" gap={3}>
                <div>
                  <span>
                    <span className="text-capitalize">
                      {payoutSchedule?.mode}
                    </span>
                    {payoutSchedule?.mode === "automatic" && (
                      <>
                        <span className="text-capitalize">
                          {" "}
                          - {payoutSchedule?.interval} -{" "}
                        </span>
                        <span>
                          {account?.settings?.payouts?.schedule?.delay_days} day
                          rolling basis
                        </span>
                      </>
                    )}
                  </span>
                </div>
                {/* <Button
                  variant="outline-light"
                size="sm"
                id="change-payout-btn"
                className="icon-button icon-button-sm icon-button--black btn-edit btn-edit--sm"
                onClick={openScheduleModal}
                  >
                    Change
                  </Button> */}
              </Stack>
            </Stack>
            <Stack as="li" direction="horizontal" gap={5}>
              <span className="me-5">Default currency</span>
              <span className="text-uppercase">
                {bankAccount?.data[0]?.currency}
              </span>
            </Stack>
          </Stack>
        </Stack>
      </Card>
    </>
  );
}
